import React, { useEffect, useState, useMemo } from "react";
import { Edit, Printer } from 'lucide-react';
import apiService from "../config";
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';

const Anusuchi2 = ({ projectId = null }) => {
  const {
    uploadStatus,
    uploadError,
    selectedSignDocument,
    resetSignatureState,
    setUploadStatus,
    setUploadError,
    signDocument
  } = useSignature();

  const [data, setData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(null);
  const [locationInfo, setLocationInfo] = useState({});
  const [debugInfo, setDebugInfo] = useState(null);
  const [proposalNo, setProposalNo] = useState('');
  const [proposalData, setProposalData] = useState(null);
  const [currentProposalId, setCurrentProposalId] = useState(null);
  const [regionalInchargeName, setRegionalInchargeName] = useState("");
  const [regionalInchargeDesignation, setRegionalInchargeDesignation] = useState("");
  const [InchargeName, setInchargeName] = useState("");
  const [InchargeDesignation, setInchargeDesignation] = useState("");
  const [signatureFile, setSignatureFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);
  const userName = userData?.full_name || 'N/A';
  const userDesi = userData?.designation || 'N/A';

  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [viewerFile, setViewerFile] = useState(null);

  const [isEditingParishisht2Header, setIsEditingParishisht2Header] = useState(false);
    const [parishisht2Header, setParishisht2Header] = useState("");
    const [parishisht2HeaderSaving, setParishisht2HeaderSaving] = useState(false);

    const getProposalId = () => {
    return localStorage.getItem('currentProposalId') || currentProposalId;
  };

  const findProposalId = (projectObj) => {
    if (!projectObj) return null;

    const possibleKeys = [
      'acquisition_proposal_no',
      'land_acquisition_no',
      'proposal_id',
      'proposalId',
      'proposal',
      'id',
      'project_id'
    ];

    for (const key of possibleKeys) {
      if (projectObj[key] !== undefined && projectObj[key] !== null && projectObj[key] !== '') {
        return projectObj[key];
      }
    }
    return null;
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const userData = JSON.parse(localStorage.getItem("userData"));
        const project = JSON.parse(localStorage.getItem("selectedProject"));
        const projectId = project?.id || project?.project_id;
        const proposalId = userData?.default_proposal || userData?.proposal_id;

        if (projectId && proposalId) {
          const result = await apiService.getProposalById(projectId, proposalId);
          if (result && result.status === 200) {
            const proposal = Array.isArray(result.data)
              ? result.data[0]
              : result.data;

            setRegionalInchargeName(proposal?.acquisition_regional_incharge_name || "");
            setRegionalInchargeDesignation(proposal?.acquisition_regional_incharge_designation || "");
            setInchargeName(proposal?.acquisition_incharge_name || "");
            setInchargeDesignation(proposal?.acquisition_incharge_designation || "");
          }
        }
      } catch (error) {
        console.error("Error loading proposal data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const fetchLandHoldings = async () => {
    setFetching(true);
    try {
      setLoading(true);
      setError(null);

      const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
      const projectIdFromStorage = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem('currentProposalId') || findProposalId(selectedProject);
      const currentProjectId = projectId || projectIdFromStorage;

      const storedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');
      if (storedProposal?.acquisition_regional_incharge_name) {
        setRegionalInchargeName(storedProposal.acquisition_regional_incharge_name);
      }
      if (storedProposal?.acquisition_regional_incharge_designation) {
        setRegionalInchargeDesignation(storedProposal.acquisition_regional_incharge_designation);
      }
      if (storedProposal?.acquisition_incharge_designation) {
        setInchargeDesignation(storedProposal.acquisition_incharge_designation);
      }
      if (storedProposal?.acquisition_incharge_name) {
        setInchargeName(storedProposal.acquisition_incharge_name);
      }

      if (!currentProjectId || !proposalId) {
        const missingParams = [];
        if (!currentProjectId) missingParams.push('projectId');
        if (!proposalId) missingParams.push('proposalId');

        setError(`Missing required parameters: ${missingParams.join(', ')}. Please select a project first.`);
        setLoading(false);
        return;
      }

      const storedLocationInfo = localStorage.getItem('selectedLocationInfo');
      let apiParams = {
        proposalId: proposalId
      };

      if (storedLocationInfo) {
        const locationData = JSON.parse(storedLocationInfo);
        apiParams = {
          ...apiParams,
         
        };
        setLocationInfo(locationData);
      }

      const result = await apiService.getLandHolding(currentProjectId, apiParams);

      if (!result || result === "" || result === null || result === undefined) {
        setError(`API returned invalid response.`);
        return;
      }

      let dataArray = null;
      let responseStatus = result?.status || result?.statusCode || 200;

      if (responseStatus === 200 || responseStatus === "200") {
        if (result.proposalData && Array.isArray(result.proposalData) && result.proposalData.length > 0) {
          const proposalInfo = result.proposalData[0];
          setProposalNo(proposalInfo.acquisition_proposal_no);
          setProposalData(proposalInfo);

          setParishisht2Header(
          proposalInfo?.parishisht2_header || proposalInfo?.acquisition_proposal_no ||
          ""
        );
        }

        if (Array.isArray(result.data)) {
          dataArray = result.data;
        } else if (result.data && Array.isArray(result.data.data)) {
          dataArray = result.data.data;
        } else if (result.data && Array.isArray(result.data.items)) {
          dataArray = result.data.items;
        } else if (result.data && Array.isArray(result.data.records)) {
          dataArray = result.data.records;
        } else if (result.data && Array.isArray(result.data.landHoldings)) {
          dataArray = result.data.landHoldings;
        }

        if (dataArray && dataArray.length > 0) {
          const firstRecord = dataArray[0];
          if (!storedLocationInfo && firstRecord) {
            const extractedLocationInfo = {
              projectId: firstRecord.project_id || currentProjectId,
              district: firstRecord.dist_name,
              taluka: firstRecord.tehsil_name || firstRecord.taluka_name,
              village: firstRecord.village_name || firstRecord.VillageName,
              districtNo: firstRecord.dist_no,
              talukaNo: firstRecord.tehsil_no,
              villageNo: firstRecord.village_no
            };
            setLocationInfo(extractedLocationInfo);
            localStorage.setItem('selectedLocationInfo', JSON.stringify(extractedLocationInfo));
          }

          const transformedData = dataArray.map((item, index) => ({
            ...item,
            sr_no: index + 1
          }));

          setData(transformedData);
        } else {
          setError(result.data ? `API returned successful response but no data records found.` : 'API returned empty response');
        }
      } else {
        setError(`API returned status ${responseStatus}: ${result?.message || result?.error || 'Unknown error'}.`);
      }
    } catch (err) {
      console.error('❌ Error fetching land holdings:', err);
      setError(`Failed to fetch land holdings data: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleParishisht2HeaderSave = async () => {
    try {
      const proposalId = getProposalId();
      if (!proposalId) return alert("Proposal ID not found");

      setParishisht2HeaderSaving(true);
      const formDataToSend = new FormData();
      formDataToSend.append("parishisht2_header", parishisht2Header || "");

      const response = await apiService.patch(`/patchUpdateProposal?proposalId=${proposalId}`, formDataToSend);
      if (response?.status === 200 || response?.status === 201) {
        alert("परिशिष्ट-2 Header updated successfully!");
        setIsEditingParishisht2Header(false);
      } else {
        alert("Failed to update परिशिष्ट-2 Header");
      }
    } catch (error) {
      console.error("Error updating परिशिष्ट-2 header:", error);
      alert("Error while updating परिशिष्ट-2 Header");
    } finally {
      setParishisht2HeaderSaving(false);
    }
  };

  const handleViewSignedPdf = async () => {
    try {
      const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem("currentProposalId");

      if (!projectId || !proposalId) {
        alert("Project or Proposal not found");
        return;
      }

      const res = await apiService.getSectionFile(projectId, proposalId, "anusuchi2");

      if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
        setViewerFile(res.data[0].file_path);
        setIsViewerOpen(true);
      } else {
        alert("Signed document not available");
      }
    } catch (error) {
      console.error("Error viewing signed PDF:", error);
      alert("Unable to open signed document");
    }
  };

  useEffect(() => {
    if (!previewUrl) {
      fetchLandHoldings();
    }
  }, [projectId]);

  useEffect(() => {
    if (!selectedSignDocument) return;

    const postSignedPdf = async () => {
      try {
        const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
        const projectId = selectedProject?.id || selectedProject?.project_id;
        const proposalId = localStorage.getItem("currentProposalId");

        if (!projectId || !proposalId) return;

        await apiService.postAddSignaturePDF(projectId, proposalId, "anusuchi2", selectedSignDocument);

        const sectionRes = await apiService.getSectionFile(projectId, proposalId, "anusuchi2");

        if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
          setPreviewUrl(sectionRes.data[0].file_path);
        }
      } catch (error) {
        console.error("Error posting signed PDF:", error);
      }
    };

    postSignedPdf();
  }, [selectedSignDocument]);

  const handleUploadedFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    resetSignatureState();
    setPdfForSigning(file);
    setShowSignaturePad(true);
  };

  // 🖨️ UPDATED PRINT FUNCTION 
  const handlePrint = () => {
    if (previewUrl) {
      window.open(previewUrl, "_blank", "noopener,noreferrer");
      return;
    }

    if (!data || data.length === 0) {
      alert("No data to print yet.");
      return;
    }

    const wasEditing = editMode;
    setEditMode(false);

    setTimeout(() => {
      const printContent = document.getElementById("notice-content")?.innerHTML;

      if (!printContent || printContent.trim() === "") {
        alert("Print content is empty.");
        setEditMode(wasEditing);
        return;
      }

      const win = window.open("", "", "height=900,width=1200");
      win.document.write(`<html><head><title>परिशिष्ट 2</title>`);
      
      // Injecting Robust CSS for Print Formatting
      win.document.write(`<style>
        @page {
          size: A4 portrait;
          margin: 0.4in; 
        }
        body {
          font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
          line-height: 1.1; 
          font-size: 13px;
        }
        .no-print { display: none !important; }
        
        table { 
          border-collapse: collapse; 
          width: 100%; 
          margin-top: 5px; 
          page-break-inside: auto; 
        }
        tr { 
          page-break-inside: avoid; 
          page-break-after: auto; 
        }
        thead { 
          display: table-header-group; 
        }
        th, td { 
          border: 1px solid black; 
          padding: 2px 4px !important; 
          text-align: center; 
          font-size: 11px; 
        }
        
        h2, h3, p { text-align: center; margin: 2px 0; padding: 0; }
        .center-text { text-align: center; }
        .left-text { text-align: left; }
        
        .keep-together { 
          page-break-inside: avoid !important; 
        }
      </style></head><body>`);
      
      win.document.write(printContent);
      win.document.write("</body></html>");
      win.document.close();
      
      setTimeout(() => {
        win.print();
      }, 200);

      setEditMode(wasEditing);
    }, 200);
  };

  const handleDownloadWord = () => {
    if (previewUrl) {
      const link = document.createElement("a");
      link.href = previewUrl;
      link.target = "_blank";
      link.download = "परिशिष्ट 2.doc";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    if (loading) {
      alert("Data is still loading. Please wait before downloading.");
      return;
    }

    const wasEditing = editMode;
    setEditMode(false);

    setTimeout(() => {
      const content = document.getElementById("notice-content").innerHTML;

      const header = `
      <html xmlns:o='urn:schemas-microsoft-com:office:office' 
            xmlns:w='urn:schemas-microsoft-com:office:word' 
            xmlns='http://www.w3.org/TR/REC-html40'>
      <head><title>अनुसूची-२</title>
      <style>
        body { font-family: 'Mangal', 'Arial', sans-serif; margin: 20mm; line-height: 1.2; }
        table { border-collapse: collapse; width: 100%; margin-top: 10px; }
        th, td { border: 1px solid black; padding: 4px; text-align: center; }
        h2, h3, p { text-align: center; margin: 0; padding: 0; }
        .center-text { text-align: center; }
        .left-text { text-align: left; }
      </style>
      </head><body>`;

      const footer = "</body></html>";
      const sourceHTML = header + content + footer;

      const blob = new Blob(['\ufeff', sourceHTML], {
        type: 'application/msword',
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `परिशिष्ट 2.doc`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      setEditMode(wasEditing);
    }, 200);
  };

  // 🔹 Group Data By Village for Rendering
  const groupedVillages = useMemo(() => {
    if (!data || data.length === 0) return [];
    const groups = {};
    data.forEach((item) => {
      const key = `${item.village_name}-${item.taluka_name}-${item.dist_name}`;
      if (!groups[key]) {
        groups[key] = {
          village_name: item.village_name,
          taluka_name: item.taluka_name,
          dist_name: item.dist_name,
          items: [],
        };
      }
      groups[key].items.push(item);
    });
    return Object.values(groups);
  }, [data]);

  const surveyTypes = ["सर्व्हे क्रमांक", "गट क्रमांक", "प्लॉट क्रमांक"];

  const SignatureLoader = ({ text }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
        <p className="text-sm font-medium text-gray-700">{text}</p>
      </div>
    </div>
  );

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-3">
          <button
            onClick={handlePrint}
            className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            <Printer size={18} />
            <span>Print</span>
          </button>
          {/* <button
            onClick={handleDownloadWord}
            className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50"
          >
            <Download size={18} />
            <span>Download Word</span>
          </button> */}
        </div>
      </div>
      
      {previewUrl ? (
        <div className="w-full bg-white p-4 rounded-lg">
          <iframe
            src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            title="Anusuchi-2 PDF"
            width="100%"
            height="800px"
            style={{
              border: "none",
              borderRadius: "8px",
              boxShadow: "none",
              outline: "none",
              margin: "0",
              padding: "0"
            }}
            frameBorder="0"
            seamless
          />
        </div>
      ) : (
        <>
          <div className="text-center mb-6">
            <div id="notice-content" style={{ margin: "10mm" }}>
              {loading ? (
                <div className="flex justify-center items-center h-96">
                  <p className="text-lg text-gray-600">Loading...</p>
                </div>
              ) : (
                <>
                  {/* Title wrapped in keep-together so it won't break across pages */}
                  <div className="keep-together" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                    <h3 className="center-text font-semibold" style={{ margin: 0, padding: 0 }}>परिशिष्ट 2</h3>
                    <h3 className="center-text" style={{ fontWeight: "bold", margin: "4px 0", padding: 0 }}>
                      प्रकल्प नाव: {data.projectName || proposalData?.project_name}
                    </h3>
                    {/* <h3 className="center-text" style={{ fontWeight: "bold", margin: "4px 0", padding: 0 }}>
                      प्रस्ताव नाव: {proposalNo}
                    </h3> */}
                    <div className="my-3">
                  {isEditingParishisht2Header ? (
                    <div className="no-print" style={{ display: "flex", gap: "8px", justifyContent: "center", alignItems: "center", flexWrap: "wrap", marginBottom: "8px" }}>
                      <input
                        type="text"
                        value={parishisht2Header}
                        onChange={(e) => setParishisht2Header(e.target.value)}
                        style={{ width: "60%", border: "1px solid #ccc", padding: "6px 8px", fontSize: "12px", borderRadius: "4px" }}
                      />
                      <button type="button" onClick={handleParishisht2HeaderSave} disabled={parishisht2HeaderSaving} style={{ backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: "4px", padding: "6px 12px", cursor: "pointer", fontSize: "12px" }}>
                        {parishisht2HeaderSaving ? "Saving..." : "Save"}
                      </button>
                      <button type="button" onClick={() => setIsEditingParishisht2Header(false)} style={{ backgroundColor: "#f44336", color: "#fff", border: "none", borderRadius: "4px", padding: "6px 12px", cursor: "pointer", fontSize: "12px" }}>
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div style={{ display: "flex", gap: "8px", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
                      <h2 className="text-md font-semibold underline m-0">{parishisht2Header}</h2>
                      <button type="button" onClick={() => setIsEditingParishisht2Header(true)} className="no-print" style={{ backgroundColor: "#2196F3", color: "#fff", border: "none", borderRadius: "4px", padding: "4px 10px", cursor: "pointer", fontSize: "12px" }}>
                        <Edit className="h-4 w-4" />
                      </button>
                    </div>
                  )}
                </div>
                    <h3 className="center-text" style={{ fontWeight: "bold", margin: "4px 0", padding: 0 }}>
                      प्रस्तावामध्ये समाविष्ट खाजगी जमिनीचा तपशील
                    </h3>
                  </div>

                  {/* 🔹 Render Village-wise Tables */}
                  {groupedVillages.map((village, vIdx) => {
                    const surveyKramankData = village.items.filter(item => surveyTypes.includes(item.survey_type));
                    const gharKramankData = village.items.filter(item => item.survey_type === "घर क्रमांक.");

                    return (
                      <div key={`village-${vIdx}`} style={{ marginTop: '20px' }}>
                        <p className="center-text" style={{ fontWeight: "bold", margin: "4px 0 8px 0", padding: 0 }}>
                          मौजे : {village.village_name} , तालुका : {village.taluka_name} , जिल्हा : {village.dist_name}
                        </p>

                        {/* Survey Data Table */}
                        {surveyKramankData.length > 0 &&
                          <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid black" }}>
                            <thead>
                              <tr>
                                <th style={{ border: "1px solid black", padding: "4px" }}>अ.क्र.</th>
                                <th style={{ border: "1px solid black", padding: "4px", minWidth: "200px" }}>भूधारकाचे नाव</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>गट/सर्व्हे</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>भूधारणा पद्धती</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>7/12 प्रमाणे एकुण क्षेत्र</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>संपादनाचे प्रस्तावित क्षेत्र (हे. आर)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {[...surveyKramankData]
                                .sort((a, b) => a.LandAcquisition_id - b.LandAcquisition_id)
                                .map((item, idx) => {
                                  const hasOwners = item.owners && item.owners.length > 0;
                                  const rowSpanValue = hasOwners ? item.owners.length : 1;

                                  return hasOwners ? (
                                    <React.Fragment key={idx}>
                                      {item.owners.map((owner, ownerIdx) => (
                                        <tr key={`${idx}-owner-${ownerIdx}`}>
                                          {ownerIdx === 0 && (
                                            <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>
                                              {idx + 1}
                                            </td>
                                          )}
                                          <td style={{ border: "1px solid black", padding: "4px", textAlign: "left", whiteSpace: "pre-line" }}>
                                            {owner.owner_name?.split(",").map((name, i, arr) => i < arr.length - 1 ? name.trim() + "," : name.trim()).join("\n")}
                                          </td>
                                          {ownerIdx === 0 && (
                                            <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>
                                              {item.survey_no}
                                            </td>
                                          )}
                                          {ownerIdx === 0 && (
                                            <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>
                                              {item.land_holding_type || "-"}
                                            </td>
                                          )}
                                          <td style={{ border: "1px solid black", padding: "4px", textAlign: "center", verticalAlign: "middle" }}>
                                            {parseFloat(owner.owner_total_area || 0).toFixed(2)}
                                          </td>
                                          <td style={{ border: "1px solid black", padding: "4px", textAlign: "center", verticalAlign: "middle" }}>
                                            {parseFloat(owner.owner_aqr_area || 0).toFixed(2)}
                                          </td>
                                        </tr>
                                      ))}
                                    </React.Fragment>
                                  ) : null;
                                })}
                              <tr>
                                <td colSpan={4} style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "right" }}>एकुण</td>
                                <td style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "center" }}>
                                  {surveyKramankData.reduce((sum, item) =>
                                    sum + (item.owners?.reduce((s, o) => s + Number(o.owner_total_area || 0), 0) || 0), 0
                                  ).toFixed(2)}
                                </td>
                                <td style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "center" }}>
                                  {surveyKramankData.reduce((sum, item) =>
                                    sum + (item.owners?.reduce((s, o) => s + Number(o.owner_aqr_area || 0), 0) || 0), 0
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        }

                        {/* Ghar Data Table */}
                        {gharKramankData.length > 0 &&
                          <table className="mt-8" style={{ borderCollapse: "collapse", width: "100%", border: "1px solid black" }}>
                            <thead>
                              <tr>
                                <th style={{ border: "1px solid black", padding: "4px" }}>अ.क्र.</th>
                                <th style={{ border: "1px solid black", padding: "4px", minWidth: "200px" }}>घर मालकाचे नाव</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>घर क्रमांक</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>भूधारणा पद्धती</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>7/12 प्रमाणे एकुण क्षेत्र</th>
                                <th style={{ border: "1px solid black", padding: "4px" }}>संपादनाचे प्रस्तावित क्षेत्र (चौरस फूट)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {[...gharKramankData]
                                .sort((a, b) => a.LandAcquisition_id - b.LandAcquisition_id)
                                .map((item, idx) => {
                                  const hasOwners = item.owners && item.owners.length > 0;
                                  const rowSpanValue = hasOwners ? item.owners.length : 1;

                                  return hasOwners ? (
                                    <React.Fragment key={idx}>
                                      {item.owners.map((owner, ownerIdx) => (
                                        <tr key={`${idx}-owner-${ownerIdx}`}>
                                          {ownerIdx === 0 && (
                                            <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>
                                              {idx + 1}
                                            </td>
                                          )}
                                          <td style={{ border: "1px solid black", padding: "4px", textAlign: "left", whiteSpace: "pre-line" }}>
                                            {owner.owner_name?.split(",").map((name, i, arr) => i < arr.length - 1 ? name.trim() + "," : name.trim()).join("\n")}
                                          </td>
                                          {ownerIdx === 0 && (
                                            <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>
                                              {item.survey_no}
                                            </td>
                                          )}
                                          {ownerIdx === 0 && (
                                            <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "4px", verticalAlign: "middle", textAlign: "center" }}>
                                              {item.land_holding_type || "-"}
                                            </td>
                                          )}
                                          <td style={{ border: "1px solid black", padding: "4px", textAlign: "center", verticalAlign: "middle" }}>
                                            {parseFloat(owner.owner_total_area || 0).toFixed(2)}
                                          </td>
                                          <td style={{ border: "1px solid black", padding: "4px", textAlign: "center", verticalAlign: "middle" }}>
                                            {parseFloat(owner.owner_aqr_area || 0).toFixed(2)}
                                          </td>
                                        </tr>
                                      ))}
                                    </React.Fragment>
                                  ) : null;
                                })}
                              <tr>
                                <td colSpan={4} style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "right" }}>एकुण</td>
                                <td style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "center" }}>
                                  {gharKramankData.reduce((sum, item) =>
                                    sum + (item.owners?.reduce((s, o) => s + Number(o.owner_total_area || 0), 0) || 0), 0
                                  ).toFixed(2)}
                                </td>
                                <td style={{ border: "1px solid black", padding: "4px", fontWeight: "bold", textAlign: "center" }}>
                                  {gharKramankData.reduce((sum, item) =>
                                    sum + (item.owners?.reduce((s, o) => s + Number(o.owner_aqr_area || 0), 0) || 0), 0
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        }
                      </div>
                    );
                  })}

                  <p style={{ textAlign: "center", marginTop: "20px", fontSize: "small" }}></p>

                  <div className="keep-together" style={{ pageBreakInside: "avoid", breakInside: "avoid", marginTop: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                      <div style={{ textAlign: "left" }}>
                        <p>दिनांक: {formattedDate}</p>
                        <p>ठिकाण:{proposalData?.acquisition_incharge_address}</p>
                      </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                      <div style={{ textAlign: "center", marginTop: "60px", lineHeight: "1.5" }}>
                        <p> {regionalInchargeName ? ` (${regionalInchargeName})` : ""}</p>
                        <p> {regionalInchargeDesignation ? ` ${regionalInchargeDesignation}` : ""}</p>
                      </div>
                      <div style={{ textAlign: "center", lineHeight: "1.5", marginTop: "60px" }}>
                        <p> {InchargeName ? ` (${InchargeName})` : ""}</p>
                        <p> {InchargeDesignation ? ` ${InchargeDesignation}` : ""}</p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}

      {showSignaturePad && pdfForSigning && (
        <SignaturePad
          pdfFile={pdfForSigning}
          onSign={(signaturesArray) => {
            setShowSignaturePad(false);
            signDocument(pdfForSigning, signaturesArray);
            setPdfForSigning(null);
          }}
          onCancel={() => {
            setShowSignaturePad(false);
            setPdfForSigning(null);
          }}
        />
      )}

      {isViewerOpen && viewerFile && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">
            <div className="flex justify-between items-center px-4 py-2 border-b">
              <h3 className="text-lg font-semibold">Signed Document</h3>
              <button
                onClick={() => setIsViewerOpen(false)}
                className="text-xl font-bold"
              >
                ✕
              </button>
            </div>
            <iframe
              src={viewerFile}
              title="Signed PDF Viewer"
              className="w-full h-full"
            />
          </div>
        </div>
      )}

      {(uploadStatus === "signing" || uploadStatus === "uploading") && (
        <SignatureLoader
          text={
            uploadStatus === "signing"
              ? "Applying digital signature…"
              : "Uploading signed document…"
          }
        />
      )}
    </div>
  );
};

export default Anusuchi2;